import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Locations from "./Locations";
import { getLocationGroupName } from "./utils";

const styles = {
  title: {
    fontSize: 22,
    color: "text.primary",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 2,
    mt: 1,
  },
  actions: {
    px: 3,
    pb: 2,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  pallets2: {
    backgroundImage: "url('/pallets-2.png')",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "100%",
    aspectRatio: "5/4",
    pl: "20%",
    pr: "10%",
    pt: "24%",
  },
  pallets3: {
    backgroundImage: "url('/pallets-3.png')",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "100%",
    aspectRatio: "5/3",
    pl: "15%",
    pr: "7%",
    pt: "16%",
  },
};

export default function SelectLocationPositionModal({ open, onClose, onSubmit, locations }) {
  const [selectedPosition, setSelectedPosition] = useState([]);

  const handleSubmit = () => {
    const selectedLocations = locations.filter(loc => selectedPosition.includes(loc.locationName));
    onSubmit(selectedLocations.length ? selectedLocations : [locations[0]]);
    onClose();
  };

  const handlePositionClick = (locationNames, isBulkOperation = false) => {
    if (isBulkOperation) {
      setSelectedPosition(locationNames);
      const selectedLocations = locations.filter(loc => locationNames.includes(loc.locationName));
      onSubmit(selectedLocations.length ? selectedLocations : [locations[0]]);
      onClose();
    } else {
      const [locationName] = locationNames;
      setSelectedPosition(prev => {
        const newSelection = prev.includes(locationName) 
          ? prev.filter(id => id !== locationName)
          : [...prev, locationName];
        
        // Auto-close only if there are only Left and Right options
        // For Left, Center, and Right, allow multiple selections and require manual submit
        if (locations.length <= 2) {
          const selectedLocations = locations.filter(loc => newSelection.includes(loc.locationName));
          onSubmit(selectedLocations.length ? selectedLocations : [locations[0]]);
          onClose();
        }
        
        return newSelection;
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={styles.title} align="center">
          Select Position(s) for
        </Typography>
        <Typography sx={{ ...styles.title, fontWeight: 500 }} align="center">
          {getLocationGroupName(locations[0])}
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={styles[`pallets${locations.length}`]}>
          <Locations
            locations={locations}
            selectedPosition={selectedPosition}
            onPositionClick={handlePositionClick}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        {locations.length > 2 && (
          <Button 
            variant="contained" 
            onClick={handleSubmit}
            disabled={selectedPosition.length === 0}
          >
            Submit
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
